import { useState } from "react";

import useAnalytics from "hooks/useAnalytics";
import { RunState, RunWorkerMetrics } from "types/generated";

import PhaseExecutionTime from "../PhaseExecutionTime";
import RunObservabilitySlowestItems from "../SlowestItems";
import { PhaseSelection } from "../SlowestItems/Card/types";

type RunObservabilityPhasesProps = {
  workerMetrics: RunWorkerMetrics;
};

const RunObservabilityPhases = ({ workerMetrics }: RunObservabilityPhasesProps) => {
  const [phaseSelection, setPhaseSelection] = useState<PhaseSelection>();
  const trackSegmentAnalyticsEvent = useAnalytics();

  const selectPhase = (phase: RunState) => {
    trackSegmentAnalyticsEvent("Run Observability - select phase", { phase });
    setPhaseSelection({ phase });
  };

  return (
    <>
      <PhaseExecutionTime workerMetrics={workerMetrics} onPhaseSelect={selectPhase} />
      <RunObservabilitySlowestItems workerMetrics={workerMetrics} phaseSelection={phaseSelection} />
    </>
  );
};

export default RunObservabilityPhases;
